module.exports = __webpack_public_path__ + "img/20260603_pengfeiwang.e9bdc051.jpg";